import * as React from "react";
const SvgFiRrShieldCat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17.002 7.335a1.325 1.325 0 0 0-.845-1.235 1.33 1.33 0 0 0-1.462.331l-.868.928a4.9 4.9 0 0 0-3.654 0l-.868-.928A1.33 1.33 0 0 0 7.843 6.1a1.325 1.325 0 0 0-.845 1.237C6.993 9.916 7 12.001 7 12.001c0 2.757 2.243 5 5 5s5-2.243 5-5c0 0 .007-2.09.002-4.666M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3c0-.024-.007-1.707-.005-2.974l.224.239c.323.344.841.417 1.246.174a2.91 2.91 0 0 1 3.07 0 1 1 0 0 0 1.246-.174l.224-.239C15.007 10.293 15 11.976 15 12m-2 .618a.62.62 0 0 1-.342.553l-.382.191a.62.62 0 0 1-.553 0l-.382-.191A.618.618 0 0 1 11.617 12h.764c.341 0 .618.277.618.618zm5.571-10.492L12.312.051a1 1 0 0 0-.629 0l-6.26 2.075a4.99 4.99 0 0 0-3.426 4.746v5.171c0 6.564 7.005 10.577 9.152 11.65 0 0 .523.307.85.307s.791-.24.791-.24c2.16-.869 9.207-4.283 9.207-11.717V6.872a4.99 4.99 0 0 0-3.426-4.746m1.427 9.917c0 6.18-6.088 9.11-7.953 9.861-1.889-.944-8.047-4.445-8.047-9.861V6.872c0-1.296.826-2.44 2.055-2.848l5.945-1.971 5.944 1.971a3 3 0 0 1 2.056 2.848z"
    />
  </svg>
);
export default SvgFiRrShieldCat;
